import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const Search = () => {
  return /*#__PURE__*/_jsx(FormControl, {
    "aria-label": I18n.text('smartLibrary.heading.searchLabel'),
    minInlineSize: "320px",
    children: /*#__PURE__*/_jsx(SearchInput, {
      placeholder: I18n.text('smartLibrary.heading.searchLabel')
    })
  });
};